import View from "./permissions-fields.view";
import Presenter from "./permissions-fields.presenter";
import { ConnectComponent } from "util";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/user/form/general-info/permissions-fields/index.js